import { CONSTANTS } from 'src/app/core/constants/constants';
import { UnitConstants } from 'src/app/core/constants/unit';
import { ValidatorsTerms } from 'src/app/shared/validators/validators-terms';

const TERMS = ValidatorsTerms;

export class RigidTubeCoatingFields {
  public static controls = {
    externalTableLength: {
      quantity: null,
      validator: null,
    },
    internalTableLength: {
      quantity: null,
      validator: null,
    },
    internalDiameter: {
      quantity: UnitConstants.QUANTITY.LENGTH,
      validator: TERMS.REQUIRED_SCI_NOTATION_MORE_THAN_ZERO,
    },
    diameterEffective: {
      quantity: UnitConstants.QUANTITY.LENGTH,
      validator: TERMS.REQUIRED_SCI_NOTATION_MORE_THAN_ZERO,
    },
  };

  public static internalTableControls = {
    layer: {
      quantity: null,
      validator: null,
      type: null,
      pastable: false,
      visible: true,
      readonly: true,
    },
    thickness: {
      quantity: UnitConstants.QUANTITY.LENGTH,
      validator: TERMS.REQUIRED_SCI_NOTATION_MORE_THAN_ZERO,
      type: CONSTANTS.FIELD_TYPES.INPUT,
      pastable: true,
      visible: true,
      readonly: false,
    },
    specificWeight: {
      quantity: UnitConstants.QUANTITY.SPECIFIC_WEIGHT,
      validator: TERMS.REQUIRED_SCI_NOTATION_MORE_THAN_ZERO,
      type: CONSTANTS.FIELD_TYPES.INPUT,
      pastable: true,
      visible: true,
      readonly: false,
    },
  };

  public static externalTableControls = {
    layer: {
      quantity: null,
      validator: null,
      type: null,
      pastable: false,
      visible: true,
      readonly: true,
    },
    thickness: {
      quantity: UnitConstants.QUANTITY.LENGTH,
      validator: TERMS.REQUIRED_SCI_NOTATION_MORE_THAN_ZERO,
      type: CONSTANTS.FIELD_TYPES.INPUT,
      pastable: true,
      visible: true,
      readonly: false,
    },
    specificWeight: {
      quantity: UnitConstants.QUANTITY.SPECIFIC_WEIGHT,
      validator: TERMS.REQUIRED_SCI_NOTATION_MORE_THAN_ZERO,
      type: CONSTANTS.FIELD_TYPES.INPUT,
      pastable: true,
      visible: true,
      readonly: false,
    },
  };

  public static externalCoatingCols = [
    { title: 'LAYER' },
    {
      title: 'THICKNESS',
      quantity: UnitConstants.QUANTITY.LENGTH,
      visibleDropdown: false,
      currentUnit: UnitConstants.DEFAULT.LENGTH,
      relatedField: 'thickness',
    },
    {
      title: 'SPECIFIC WEIGHT',
      quantity: UnitConstants.QUANTITY.SPECIFIC_WEIGHT,
      visibleDropdown: false,
      currentUnit: UnitConstants.DEFAULT.SPECIFIC_WEIGHT,
      relatedField: 'specificWeight',
    },
  ];

  public static internalCoatingCols = [
    { title: 'LAYER' },
    {
      title: 'THICKNESS',
      quantity: UnitConstants.QUANTITY.LENGTH,
      visibleDropdown: false,
      currentUnit: UnitConstants.DEFAULT.LENGTH,
      relatedField: 'thickness',
    },
    {
      title: 'SPECIFIC WEIGHT',
      quantity: UnitConstants.QUANTITY.SPECIFIC_WEIGHT,
      visibleDropdown: false,
      currentUnit: UnitConstants.DEFAULT.SPECIFIC_WEIGHT,
      relatedField: 'specificWeight',
    },
  ];
}
